var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErj190(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 543.366,
    height: 301.999,
    viewBox: "0 0 543.366 301.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AVION",
    transform: "translate(-808.57 -166.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M250.76,431.611c-7.762.433-23.081,4.005-41.975,8.01S169.433,452.6,169.433,452.6c-2.287,1.1-4.945,2.881-4.945,5.543s2.572,4.527,4.893,5.543l1.555.7c5.232,2.192,22.005,8.946,37.7,12.273,18.894,4.005,34.213,7.577,41.975,8.01",
    transform: "translate(644.082 -140.637)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M265.746,460.417l-10.646,1.53s-.245.551.857,1.346,1.652,1.346,3.549.979,6.241-1.469,6.241-1.469Z",
    transform: "translate(587.647 -158.602)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M265.746,535.427,255.1,533.9s-.245-.55.857-1.346,1.652-1.346,3.549-.979,6.241,1.469,6.241,1.469Z",
    transform: "translate(587.647 -202.82)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M-15255.971-1558.01a5.426,5.426,0,0,1-4.607-2.684l-61.421-77.86,13.608-2.626v-36.73l-13.608-2.549,61.421-77.856a5.426,5.426,0,0,1,4.607-2.684h9.417l-28.883,97.544h-.177a19.828,19.828,0,0,1,4.118,1.984,138.8,138.8,0,0,1,18.927,1.661l.077.012h.008v0c.415.086.719.346.719.656,0,.374-.443.68-.991.684-1.8.146-11.837.389-11.837.389l.033,0a65.1,65.1,0,0,1-6.936.008,19.547,19.547,0,0,1-4.1,1.977l29.044,98.079Z",
    transform: "translate(16597.82 1977.042)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M240.394,471.207s-7.071,11.6,0,22.618c0-.165,4.979-1.432,4.979-1.432s-5.139-9.589,0-19.914Z",
    transform: "translate(598.752 -165.305)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(976.522 167)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_16",
    "data-name": "Union 16",
    d: "M-16282.953-1804.24s17.237-12.148,29.586-28.514a129.77,129.77,0,0,1-36.335,1.383c-6.88-.818-8.782-3.17-8.782-3.17s-.09-23.626,0-23.679c5.887-5.3,21.725-5.015,32.589-4.561,9.4.389,24.178,3.522,27.986,4.356,15.482-27.553,38.45-69.574,38.45-69.574h52.623l-16.146,45.436-3.27,10.639h5.814s9.592,2.082,9.5,3.62-6.606,2.626-10.591,2.716-6.671,0-6.671,0l.012-.043-4.794,15.6v9.7h4.029s5.433,1.9,5.162,2.622-2.708,1.792-5.976,1.992c-1.785.111-2.729.175-3.216.209v31.271Z",
    transform: "translate(16298.522 1928)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M696.788,309.745s-4.1.166-11.794.437-22.9-.09-26.159,3.44,4.8,4.526,12.582,5.16,18.375.543,18.375.543c.588,0,1.027-.011,1.379-.039.176-.014.331-.032.472-.055h.008a3.808,3.808,0,0,0,.4-.087,21.508,21.508,0,0,0,6.563-2.891h0a27.225,27.225,0,0,0,4.574-3.153C704.908,311.578,696.788,309.745,696.788,309.745Z",
    transform: "translate(-639.839 -231.931)",
    fill: "#003d64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393",
    transform: "translate(976.522 344.238)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M-16199.459-1981.477s-22.968-42.021-38.45-69.574c-3.809.834-18.587,3.964-27.986,4.356-10.864.454-26.7.74-32.589-4.565-.09-.053,0-23.675,0-23.675s1.9-2.356,8.782-3.17a129.6,129.6,0,0,1,36.335,1.383c-12.349-16.366-29.586-28.514-29.586-28.514h109.975v31.271c.487.034,1.431.1,3.216.205,3.268.2,5.7,1.268,5.976,1.992s-5.162,2.626-5.162,2.626h-4.029v9.694l4.788,15.581-.006-.021s2.691-.09,6.671,0,10.5,1.178,10.591,2.716-9.5,3.62-9.5,3.62h-5.813l3.269,10.639,16.146,45.436Z",
    transform: "translate(16298.522 2105.238)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M696.788,678.353s-4.1-.166-11.794-.437-22.9.09-26.159-3.44,4.8-4.526,12.582-5.159,18.375-.543,18.375-.543c.588,0,1.027.011,1.379.039.176.014.331.032.472.055h0l.008,0a3.733,3.733,0,0,1,.4.087,21.5,21.5,0,0,1,6.563,2.89h0A27.227,27.227,0,0,1,703.188,675C704.908,676.52,696.788,678.353,696.788,678.353Z",
    transform: "translate(-639.839 -632.407)",
    fill: "#003d64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M1163.364,431.611",
    transform: "translate(21.971 -140.675)",
    fill: "none",
    stroke: "#6b6b6b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M683.328,484.54H392.811V431.111H683.328v.377H393.188v52.675h290.14Z",
    transform: "translate(501.929 -140.326)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M1163.363,484.54v-.377c14.455,0,49.346-1.388,74.621-3.9,22.317-2.216,28.338-4.023,29.208-4.317V439.7c-.87-.294-6.891-2.1-29.208-4.317-25.275-2.509-60.166-3.9-74.621-3.9v-.377c14.463,0,49.372,1.389,74.659,3.9,24.4,2.423,29.236,4.305,29.43,4.384l.118.048v36.765l-.118.048c-.193.079-5.027,1.962-29.43,4.384C1212.735,483.151,1177.826,484.54,1163.363,484.54Z",
    transform: "translate(22.047 -140.326)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    transform: "translate(947.875 317.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M536.931,503.437h-.5a.937.937,0,0,0-.993-.9c-.708,0-1.141.57-1.141,1.511s.428,1.51,1.125,1.51a.987.987,0,0,0,1.025-.924h.507A1.425,1.425,0,0,1,535.421,506c-1.009,0-1.632-.739-1.632-1.954s.628-1.954,1.648-1.954A1.385,1.385,0,0,1,536.931,503.437Z",
    transform: "translate(-533.789 -502.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M546.889,504.044c0,1.2-.66,1.954-1.706,1.954s-1.706-.755-1.706-1.954.66-1.954,1.706-1.954S546.889,502.846,546.889,504.044Zm-2.9,0c0,.924.459,1.51,1.2,1.51s1.2-.586,1.2-1.51-.465-1.511-1.2-1.511S543.985,503.12,543.985,504.044Z",
    transform: "translate(-539.825 -502.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M557.907,506.046v-1.912c0-.475.006-.956.011-1.436h-.011c-.163.48-.338.956-.512,1.436l-.7,1.912h-.56l-.7-1.912c-.175-.481-.349-.956-.512-1.436h-.01c0,.48.01.961.01,1.436v1.912h-.475v-3.76h.782l.682,1.854c.169.475.338.966.5,1.442h.011c.158-.475.327-.966.5-1.442l.676-1.854h.787v3.76Z",
    transform: "translate(-546.662 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M568.818,502.286c.866,0,1.315.449,1.315,1.136s-.449,1.135-1.315,1.135h-.8v1.49h-.486v-3.76Zm-.8,1.849h.766c.57,0,.85-.27.85-.713s-.28-.713-.85-.713h-.766Z",
    transform: "translate(-554.808 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M574.884,504.927l-.412,1.12h-.518l1.426-3.76h.66l1.431,3.76h-.523l-.406-1.12Zm1.378-.771c-.19-.523-.365-1.009-.544-1.532h-.01c-.179.523-.354,1.009-.544,1.532l-.127.343h1.347Z",
    transform: "translate(-558.811 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M585.579,502.286c.908,0,1.32.38,1.32,1.019a.919.919,0,0,1-.719.94v.011c.275.084.4.243.565.708l.386,1.083H586.6l-.344-.993c-.153-.449-.327-.592-.728-.592h-.66v1.585h-.486v-3.76Zm-.708,1.764h.7c.586,0,.829-.3.829-.708,0-.438-.312-.639-.861-.639h-.671Z",
    transform: "translate(-565.309 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M593.467,502.719v3.328h-.491v-3.328h-1.284v-.433h3.058v.433Z",
    transform: "translate(-569.861 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M601,506.046v-3.76h.486v3.76Z",
    transform: "translate(-575.662 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M608.4,506.046v-1.912c0-.475.006-.956.011-1.436H608.4c-.163.48-.338.956-.512,1.436l-.7,1.912h-.56l-.7-1.912c-.175-.481-.348-.956-.512-1.436h-.01c0,.48.01.961.01,1.436v1.912h-.475v-3.76h.782l.682,1.854c.169.475.338.966.5,1.442h.011c.158-.475.327-.966.5-1.442l.676-1.854h.787v3.76Z",
    transform: "translate(-578.121 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M618.512,502.719v1.189h1.827v.428h-1.827v1.278h2v.433h-2.482v-3.76h2.424v.433Z",
    transform: "translate(-586.267 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M628.949,506.046l-.892-1.622c-.312-.56-.618-1.125-.908-1.685h-.011c.011.6.016,1.2.016,1.8v1.505h-.475v-3.76h.713l.9,1.622c.307.56.613,1.125.908,1.684h.011c-.011-.6-.016-1.2-.016-1.8v-1.505h.475v3.76Z",
    transform: "translate(-591.657 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M637.566,502.719v3.328h-.491v-3.328h-1.283v-.433h3.058v.433Z",
    transform: "translate(-597.334 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M647.562,504.044c0,1.2-.66,1.954-1.706,1.954s-1.706-.755-1.706-1.954.66-1.954,1.706-1.954S647.562,502.846,647.562,504.044Zm-2.9,0c0,.924.459,1.51,1.2,1.51s1.2-.586,1.2-1.51-.465-1.511-1.2-1.511S644.657,503.12,644.657,504.044Z",
    transform: "translate(-602.541 -502.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M535.664,519.086a1.881,1.881,0,1,1,0,3.76h-1.146v-3.76Zm-.66,3.327h.655a1.447,1.447,0,0,0,0-2.894H535Z",
    transform: "translate(-534.243 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M545.126,519.519v1.189h1.827v.427h-1.827v1.278h2v.433H544.64v-3.76h2.424v.433Z",
    transform: "translate(-540.549 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M555.7,522.413v.433h-2.408v-3.76h.486v3.327Z",
    transform: "translate(-545.938 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M560.814,521.727l-.412,1.119h-.518l1.426-3.76h.66l1.431,3.76h-.523l-.407-1.119Zm1.378-.771c-.19-.523-.365-1.009-.544-1.532h-.011c-.179.523-.354,1.009-.544,1.532l-.127.343h1.347Z",
    transform: "translate(-550.046 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M572.586,522.846l-.892-1.621c-.312-.56-.618-1.125-.909-1.685h-.01c.01.6.016,1.2.016,1.8v1.505h-.475v-3.76h.713l.9,1.622c.306.559.613,1.125.908,1.684h.011c-.011-.6-.016-1.2-.016-1.8v-1.505h.475v3.76Z",
    transform: "translate(-556.544 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M581.2,519.519v3.327h-.491v-3.327h-1.283v-.433h3.058v.433Z",
    transform: "translate(-562.222 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M589.225,519.519v1.189h1.827v.427h-1.827v1.278h2v.433h-2.482v-3.76h2.424v.433Z",
    transform: "translate(-568.022 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M598.585,519.086c.908,0,1.32.38,1.32,1.019a.919.919,0,0,1-.719.94v.01c.275.085.4.243.565.708l.386,1.082h-.528l-.343-.993c-.153-.449-.327-.592-.728-.592h-.66v1.584h-.486v-3.76Zm-.708,1.764h.7c.586,0,.829-.3.829-.708,0-.438-.312-.639-.861-.639h-.671Z",
    transform: "translate(-573.412 -512.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M608.937,520.843c0,1.2-.66,1.954-1.706,1.954s-1.706-.755-1.706-1.954.66-1.954,1.706-1.954S608.937,519.645,608.937,520.843Zm-2.9,0c0,.924.459,1.51,1.2,1.51s1.2-.586,1.2-1.51-.465-1.511-1.2-1.511S606.032,519.919,606.032,520.843Z",
    transform: "translate(-578.479 -512.555)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395",
    transform: "translate(1093.002 317.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M922.144,503.438h-.5a.937.937,0,0,0-.993-.9c-.708,0-1.141.571-1.141,1.511s.427,1.51,1.125,1.51a.987.987,0,0,0,1.024-.924h.507A1.425,1.425,0,0,1,920.634,506c-1.009,0-1.632-.739-1.632-1.954s.628-1.954,1.648-1.954A1.385,1.385,0,0,1,922.144,503.438Z",
    transform: "translate(-918.827 -502.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M932.1,504.045c0,1.2-.66,1.954-1.706,1.954s-1.706-.755-1.706-1.954.66-1.954,1.706-1.954S932.1,502.847,932.1,504.045Zm-2.9,0c0,.924.46,1.51,1.2,1.51s1.2-.586,1.2-1.51-.465-1.511-1.2-1.511S929.2,503.12,929.2,504.045Z",
    transform: "translate(-924.862 -502.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M943.12,506.047v-1.912c0-.475.005-.957.01-1.436h-.01c-.164.48-.338.956-.512,1.436l-.7,1.912h-.56l-.7-1.912c-.174-.481-.349-.957-.512-1.436h-.011c.005.48.011.961.011,1.436v1.912h-.475v-3.761h.781l.681,1.854c.169.475.338.966.5,1.442h.011c.158-.476.327-.967.5-1.442l.676-1.854h.787v3.761Z",
    transform: "translate(-931.701 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M954.03,502.286c.866,0,1.315.449,1.315,1.136s-.449,1.135-1.315,1.135h-.8v1.49h-.486v-3.761Zm-.8,1.849h.766c.57,0,.85-.27.85-.713s-.28-.713-.85-.713h-.766Z",
    transform: "translate(-939.846 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M960.1,504.927l-.412,1.12h-.518l1.426-3.761h.66l1.431,3.761h-.523l-.407-1.12Zm1.378-.771c-.19-.523-.365-1.009-.544-1.532h-.011c-.18.523-.354,1.009-.544,1.532l-.127.343H961.6Z",
    transform: "translate(-943.849 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M970.792,502.286c.908,0,1.32.381,1.32,1.02a.919.919,0,0,1-.719.94v.011c.275.084.4.243.565.708l.386,1.083h-.529l-.343-.993c-.153-.449-.327-.592-.729-.592h-.66v1.585H969.6v-3.761Zm-.708,1.764h.7c.586,0,.829-.3.829-.708,0-.439-.311-.639-.861-.639h-.67Z",
    transform: "translate(-950.348 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M978.679,502.719v3.328h-.491v-3.328h-1.283v-.433h3.058v.433Z",
    transform: "translate(-954.9 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M986.215,506.047v-3.761h.486v3.761Z",
    transform: "translate(-960.7 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M993.617,506.047v-1.912c0-.475.005-.957.01-1.436h-.01c-.164.48-.338.956-.512,1.436l-.7,1.912h-.559l-.7-1.912c-.174-.481-.349-.957-.512-1.436h-.011c0,.48.011.961.011,1.436v1.912h-.475v-3.761h.782l.681,1.854c.169.475.338.966.5,1.442h.011c.158-.476.327-.967.5-1.442l.676-1.854h.787v3.761Z",
    transform: "translate(-963.159 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M1003.724,502.719v1.189h1.827v.428h-1.827v1.278h2v.433h-2.482v-3.761h2.424v.433Z",
    transform: "translate(-971.304 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M1014.162,506.047l-.892-1.622c-.312-.56-.618-1.125-.909-1.685h-.011c.011.6.016,1.2.016,1.8v1.505h-.475v-3.761h.713l.9,1.622c.306.56.613,1.125.908,1.685h.011c-.011-.6-.016-1.2-.016-1.8v-1.505h.475v3.761Z",
    transform: "translate(-976.695 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M1022.779,502.719v3.328h-.491v-3.328H1021v-.433h3.058v.433Z",
    transform: "translate(-982.372 -502.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M1032.774,504.045c0,1.2-.66,1.954-1.706,1.954s-1.706-.755-1.706-1.954.66-1.954,1.706-1.954S1032.774,502.847,1032.774,504.045Zm-2.9,0c0,.924.459,1.51,1.2,1.51s1.2-.586,1.2-1.51-.465-1.511-1.2-1.511S1029.869,503.12,1029.869,504.045Z",
    transform: "translate(-987.579 -502.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M920.314,519.52v3.327h-.491V519.52h-1.283v-.433H921.6v.433Z",
    transform: "translate(-918.539 -512.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M929.044,519.087c.908,0,1.32.38,1.32,1.019a.92.92,0,0,1-.719.94v.01c.275.085.4.243.565.708l.386,1.082h-.528l-.344-.992c-.153-.449-.327-.592-.728-.592h-.66v1.584h-.486v-3.76Zm-.708,1.763h.7c.586,0,.829-.3.829-.708,0-.438-.312-.639-.861-.639h-.671Z",
    transform: "translate(-924.34 -512.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M936.479,521.728l-.412,1.119h-.518l1.426-3.76h.66l1.431,3.76h-.523l-.406-1.119Zm1.378-.771c-.19-.523-.365-1.009-.544-1.532H937.3c-.179.523-.354,1.009-.544,1.532l-.127.343h1.347Z",
    transform: "translate(-929.136 -512.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M947.941,520.126h-.491c0-.555-.306-.819-.861-.819-.465,0-.745.227-.745.586,0,.4.291.518.908.671.713.175,1.278.353,1.278,1.125,0,.676-.528,1.109-1.346,1.109a1.237,1.237,0,0,1-1.405-1.32h.5a.81.81,0,0,0,.909.9c.538,0,.84-.248.84-.665s-.312-.523-.919-.676c-.723-.179-1.262-.359-1.262-1.114,0-.608.48-1.036,1.246-1.036C947.492,518.889,947.941,519.312,947.941,520.126Z",
    transform: "translate(-935.197 -512.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M955.076,519.52v1.188H956.9v.428h-1.827v1.278h2v.433H954.59v-3.76h2.424v.433Z",
    transform: "translate(-940.998 -512.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M964.435,519.087c.908,0,1.32.38,1.32,1.019a.92.92,0,0,1-.718.94v.01c.274.085.4.243.565.708l.385,1.082h-.528l-.344-.992c-.153-.449-.327-.592-.729-.592h-.66v1.584h-.486v-3.76Zm-.708,1.763h.7c.586,0,.829-.3.829-.708,0-.438-.312-.639-.861-.639h-.671Z",
    transform: "translate(-946.387 -512.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M974.788,520.843c0,1.2-.66,1.954-1.706,1.954s-1.706-.756-1.706-1.954.66-1.954,1.706-1.954S974.788,519.645,974.788,520.843Zm-2.9,0c0,.924.459,1.51,1.2,1.51s1.2-.586,1.2-1.51-.465-1.51-1.2-1.51S971.883,519.919,971.883,520.843Z",
    transform: "translate(-951.455 -512.556)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M564.363,488.939H445.018V446.265H484.6v13.519h26.661V446.265h53.1ZM445.4,488.562H563.986v-41.92H511.638v13.519H484.223V446.642H445.4Z",
    transform: "translate(469.383 -149.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M846.807,488.934h-.188V446.258l.191,0,92.176,1.359.36,13.3h23.888v-11.43l.206.019,41.729,3.906v29.114l-.173.014-75.706,6.4Zm.188-.377h82.278l75.518-6.38V453.753L963.611,449.9v11.393H938.979l-.36-13.3L847,446.641Z",
    transform: "translate(219.289 -149.761)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErj190);
export default __webpack_public_path__ + "static/media/erj-190.a3ff2217881a4faf7a4a44732e51eb0e.svg";
export { ForwardRef as ReactComponent };